// react and js
import { React, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";

// mui
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";

// components

// hooks
import defines from "../hooks/defines";
import appContext from "../hooks/appContext";

// layouts
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function Public() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  // eslint-disable-next-line
  const { stateStorage, setStateStorage } = useContext(appContext);
  const myLocalStateStorage = JSON.parse(
    localStorage.getItem("myLocalStateStorage")
  );
  const location = useLocation();

  return !(
    stateStorage.authenticated === true &&
    myLocalStateStorage !== null &&
    location.pathname !== "/new-password" &&
    location.pathname !== "/invoice-printer"
  ) ? (
    <>
      <Box
        sx={{
          zIndex: -1000,
          position: "absolute",
          top: isDesktop
            ? defines.headerHeightDesktop
            : defines.headerHeightMobile,
          left: 0,
          width: "100%",
          height: isDesktop
            ? `calc(100vh - ${defines.headerHeightDesktop}px)`
            : `calc(100vh - ${defines.headerHeightMobile}px)`,
          overflow: "hidden",

          // Animated futuristic gradient background
          background: `
            linear-gradient(
              -45deg,
              #0f0f0f,
              #1a1a2e,
              #16213e,
              #0f0f0f,
              rgb(20, 40, 77),
              rgb(30, 58, 107),
              #0f0f0f
            )
          `,
          backgroundSize: "400% 400%",
          animation: "futuristicGradient 20s ease infinite",
          // CSS animation keyframes for gradient
          "@keyframes futuristicGradient": {
            "0%": {
              backgroundPosition: "0% 50%",
            },
            "50%": {
              backgroundPosition: "100% 50%",
            },
            "100%": {
              backgroundPosition: "0% 50%",
            },
          },
          // Animated white spot overlay
          "&::before": {
            content: '""',
            position: "absolute",
            width: "60%",
            height: "60%",
            top: "20%",
            left: "20%",
            pointerEvents: "none",
            background: `
              radial-gradient(
                circle at 50% 50%,
                rgba(255, 255, 255, 0.08) 0%,
                rgba(255, 255, 255, 0.04) 15%,
                rgba(255, 255, 255, 0.02) 25%,
                transparent 35%
              )
            `,
            animation: "movingSpot 15s ease-in-out infinite",
            zIndex: 1,
          },
          // Animation for the moving white spot
          "@keyframes movingSpot": {
            "0%": {
              transform: "translate(0%, 0%) scale(1)",
            },
            "25%": {
              transform: "translate(-30%, 20%) scale(1.2)",
            },
            "50%": {
              transform: "translate(20%, -30%) scale(0.8)",
            },
            "75%": {
              transform: "translate(-20%, -20%) scale(1.1)",
            },
            "100%": {
              transform: "translate(0%, 0%) scale(1)",
            },
          },
        }}
      />

      <Box
        id="auto-scroll-container"
        style={{
          marginTop: isDesktop
            ? defines.headerHeightDesktop
            : defines.headerHeightMobile,
          maxHeight: isDesktop
            ? `calc(100vh - ${defines.headerHeightDesktop}px)`
            : `calc(100vh - ${defines.headerHeightMobile}px)`,
          overflow: "auto",
        }}
      >
        <PublicHeader />
        <Stack
          direction="column"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
          sx={{
            minHeight: isDesktop
              ? `calc(100vh - ${defines.headerHeightDesktop}px)`
              : `calc(100vh - ${defines.headerHeightMobile}px)`,
          }}
        >
          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ my: 6, width: "100%" }}>
            <Outlet />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <PublicFooter />
        </Stack>
      </Box>
    </>
  ) : null;
}
